import React from 'react';
import css from './CalendarLoading.module.scss';

export const CalendarLoading = () => {
  return <div className={css.loading} />;
};
